import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Menu } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { DATETIME_FORMAT_FOR_DISPLAY } from "../../constants/constants";
import { getInitials } from "../../libs/utils";
import { getUID } from "../../store/services/tokenFunc";
import NewNote from "./newNoteContent";
import Content from "./noteContent";

const Note = props => {
  const {
    note,
    index,
    docId,
    modifyNoteError,
    modifyNoteText,
    modifyNoteState,
    noteId,
    noteStatus,
    newNoteError,
    newNoteText,
    modifyNoteConfirm,
    cleanModify,
    cleanAddInput,
    typeAccount,
    createNewNote,
    addNewNote,
    setModifyNoteText,
    startDeleteNote,
    setNewNoteText
  } = props;

  const auth = useSelector(state => state.auth);
  const user = useSelector(state => state.user);

  const uid = getUID(auth.loginAuth.securityToken);
  const userName = user.profile ? user.profile.firstName + " " + user.profile.lastName : null;

  const classNameMore =
      (note && (note.createdBy === user.profile.id || note.createdBy === uid)) && index !== 0
        ? "activeMore"
        : "disableMore";

  /** il blocco menu con la richiesta di render singole voci per le operazioni sulla singola nota */
  function renderNoteMenu(noteId, actualText) {
    return (
      <div
        style={{
          boxShadow: "0 2px 20px 0 rgba(0, 0, 0, 0.2)",
          width: "150px",
          textAlign: "right"
        }}
      >
        <Menu>
          <Menu.Item onClick={() => modifyNoteState(noteId, actualText)}>
            <span>Modifica</span>
          </Menu.Item>
          <Menu.Item onClick={() => startDeleteNote(noteId)}>
            <span>Elimina</span>
          </Menu.Item>
        </Menu>
      </div>
    );
  }

  return (
    <div key={"note" + index + docId} className={note ? classNameMore : ""}>
      <div
        id={"boxNote_" + index}
        className={"boxNote arrow-right-center " + (note ? (note.itemClassifier === "STUDIO" ? "right" : "left") : (typeAccount === "STUDIO" ? "right" : "left"))}
      >
        <div>
          <div className="roundUser" style={{ display: "inline-flex" }}>
            {getInitials(note ? note.userName : userName)}
          </div>
          <div className="headingNote">
            <span className="noteUser">{note ? note.userName : userName}</span>
            <br />
            {note && <span className="noteTime">
              {note.createdOn
                ? moment(note.createdOn).format(DATETIME_FORMAT_FOR_DISPLAY)
                : null}
            </span>}
          </div>
          <div
            className={classNameMore}
            style={{ float: "right", fontSize: "20px", cursor: "pointer" }}
          >
            <Dropdown
              disabled={classNameMore === "disableMore"}
              trigger={["click"]}
              overlay={!addNewNote ? renderNoteMenu(note.id, note.noteText) : null}
            >
              <FontAwesomeIcon icon={["fal", "ellipsis-v"]} />
            </Dropdown>
          </div>
        </div>
        <div className="noteContent">
          {note && <Content
            note={note}
            modifyNoteError={modifyNoteError}
            modifyNoteText={modifyNoteText}
            noteId={noteId}
            noteStatus={noteStatus}
            modifyNoteConfirm={modifyNoteConfirm}
            cleanModify={cleanModify}
            setModifyNoteText={setModifyNoteText}
          />}
          {addNewNote && <NewNote
            createNewNote={createNewNote}
            modifyNoteError={modifyNoteError}
            setNewNoteText={setNewNoteText}
            newNoteText={newNoteText}
            noteStatus={noteStatus}
            newNoteError={newNoteError}
            cleanAddInput={cleanAddInput}
          />}
        </div>
      </div>
    </div>
  );
};

export default Note;
